import React from "react";
import { Route, Routes } from "react-router-dom";
import Main from "./pages/Main/index";
import Edit from "./pages/Edit";

const EditRangeDates: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="range-date/:rangeDateId?" element={<Edit />} />
    </Routes>
  );
};

export default EditRangeDates;
